<template>
      <!-- Big White Footer V2 -->
      <footer class="footer footer-white footer-big">
        <div class="container">
          <div class="content">
            <div class="md-layout">
              <div
                class="md-layout-item md-medium-size-25 md-large-size-25 md-small-size-100"
              >
                <a href="javascript:void(0)"><h5>{{title}}</h5></a>
                <p>
                  {{description}}
                </p>
              </div>
              <div
                class="md-layout-item md-medium-size-15 md-large-size-15 md-small-size-100"
              >
                <h5>About</h5>
                <ul class="links-vertical">
                  <li>
                    <a href="javascript:void(0)">
                      Blog
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      About Us
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      Presentation
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
              <div
                class="md-layout-item md-medium-size-15 md-large-size-15 md-small-size-100"
              >
                <h5>Market</h5>
                <ul class="links-vertical">
                  <li>
                    <a href="javascript:void(0)">
                      Sales FAQ
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      How to Register
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      Sell Goods
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      Receive Payment
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      Transactions Issues
                    </a>
                  </li>
                </ul>
              </div>

              <div
                class="md-layout-item md-medium-size-15 md-large-size-15 md-small-size-100"
              >
                <h5>Legal</h5>
                <ul class="links-vertical">
                  <li>
                    <a href="javascript:void(0)">
                      Transactions FAQ
                    </a>
                  </li>
                  <li>
                    <a href="#pablo">
                      Terms &amp; Conditions
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      Licenses
                    </a>
                  </li>
                </ul>
              </div>
              <div
                class="md-layout-item md-medium-size-25 md-large-size-25 md-small-size-100"
              >
                <h5>Subscribe to Newsletter</h5>
                <p>
                  Join our newsletter and get news in your inbox every week! We
                  hate spam too, so no worries about this.
                </p>
                <form
                  class="form-newsletter"
                  action=""
                  method=""
                >
                  <div class="md-layout">
                    <div class="md-layout-item md-large-size-66 medium-size-50">
                      <md-field>
                        <!-- v model removed from below -->
                        <md-input
                          placeholder="Your Email.."
                        />
                      </md-field>
                    </div>
                    <div class="md-layout-item md-large-size-33 medium-size-50">
                      <md-button
                        class="md-primary md-just-icon md-block"
                      >
                        <md-icon>mail</md-icon>
                      </md-button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <hr>

          <ul class="social-buttons">
            <li>
              <md-button
                href="javascript:void(0)"
                target="_blank"
                class="md-twitter md-just-icon md-simple"
              >
                <i class="fab fa-twitter" />
              </md-button>
            </li>
            <li>
              <md-button
                href="javascript:void(0)"
                target="_blank"
                class="md-facebook md-just-icon md-simple"
              >
                <i class="fab fa-facebook" />
              </md-button>
            </li>
            <li>
              <md-button
                href="javascript:void(0)"
                target="_blank"
                class="md-dribbble md-just-icon md-simple"
              >
                <i class="fab fa-dribbble" />
              </md-button>
            </li>
            <li>
              <md-button
                href="javascript:void(0)"
                target="_blank"
                class="md-google md-just-icon md-simple"
              >
                <i class="fab fa-google" />
              </md-button>
            </li>
            <li>
              <md-button
                href="javascript:void(0)"
                target="_blank"
                class="md-youtube md-just-icon md-simple"
              >
                <i class="fab fa-youtube" />
              </md-button>
            </li>
          </ul>

          <div class="copyright">
            Copyright © {{ year }} Artysan India. All Rights Reserved.
          </div>
        </div>
      </footer>
      <!-- end Big White Footer V2 -->

</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
    size: String
  },
  data() {
    return {
      year: new Date().getFullYear(),
      img1: require("@/assets/img/faces/card-profile6-square.jpg"),
      img2: require("@/assets/img/faces/christian.jpg"),
      img3: require("@/assets/img/faces/card-profile4-square.jpg"),
      img4: require("@/assets/img/faces/card-profile1-square.jpg"),
      img5: require("@/assets/img/faces/marc.jpg"),
      img6: require("@/assets/img/faces/kendall.jpg"),
      img7: require("@/assets/img/faces/card-profile5-square.jpg"),
      img8: require("@/assets/img/faces/card-profile2-square.jpg"),
      title: 'Artysan',
      description: 'The artisans of new India, we are people who have been here since a long time. We love mathematics and art, and we shall build a wall larger than anyone has ever seen. And MEXICO WILL PAY FOR IT.'
    };
  }
};
</script>
<style></style>
